<template>
  <v-app :class="$props.darkMode ? '' : 'la-creme'" class="d-flex" >
    <div class="text-center grey--text text--darken-2 " style="height:100%">
      <div>
        <h1 class="error-page-title ">404</h1>
        <span class="headline">This Page Does Not Exist</span>
      </div>
      <v-btn class="mt-5" to="/" dark color="grey darken-1">Go To Homepage</v-btn>

    </div>
  </v-app>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'ErrorPage',
  props:{
    darkMode:{
      type:Boolean,
      default: false
    },
  }
}
</script>

<style lang="scss" scoped>
  .error-page-title{
    font-size: 4rem;
  }
</style>